import _mountView from 'rlink-router/actions/_mountView';
import _loadView from 'rlink-router/actions/_loadView';
import closeAllModals from 'rlink-router/actions/closeAllModals';
import getCurrentRouteState from 'rlink-router/getCurrentRouteState';
import animationFrame from 'rlink-await-animation-frame';
import hideTooltip from 'rlink-tooltips/actions/hideTooltip';

const CONTENT_AUTHORING_LOCALE = 'en';

export default function returnTo (buildContext, {view, params, transition, returnTransition, scrollPosition}, direction = 0) {
  return (dispatch, getSate) => {

    let {
      view: currentView,
      params: {
        region: _region1, locale: _locale1, ...currentParams} = {},
      } = getCurrentRouteState(getSate().routing);
    let {region: _region2, locale: _locale2, ...nonLocaleParams} = params || {};

    // console.log('>>>>returnTo', JSON.stringify({view, nonLocaleParams, currentView, currentParams}));
    if (currentView === view
        && Object.keys(nonLocaleParams).length === Object.keys(currentParams).length) {
      let paramsAreIdentical = true;
      for (let paramName in nonLocaleParams) {
        if (nonLocaleParams[paramName] !== currentParams[paramName]) {
          paramsAreIdentical = false;
          break;
        }
      }
      if (paramsAreIdentical) {
        return Promise.resolve(); // DO NOTHING
      }
    }
    return Promise.all([
      dispatch(_loadView(buildContext, view, params)),
      dispatch(hideTooltip()),
      dispatch(closeAllModals()),
    ]).then(async ([content, _]) => {
      let directionalTransition = null;
      if (direction > 0) {
        directionalTransition = transition;
      }
      if (direction < 0) {
        directionalTransition = returnTransition;
      }
      await animationFrame();
      return dispatch(_mountView({
        view, params,
        transition: directionalTransition,
        content,
        scrollPosition,
      }));
    }, err => {
      if (err && err.missingContent
        && params.locale !== CONTENT_AUTHORING_LOCALE) {
        console.warn(`Falling back to authoring locale due to missing content at ${err.missingContent}`);
        return dispatch(returnTo(buildContext, {
          view,
          params: {...params, locale: CONTENT_AUTHORING_LOCALE},
          scrollPosition,
          transition,
          returnTransition,
        }));
      }
      return Promise.reject(err);

    });
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/returnTo.js